// ./src/components/loadings/LoadingButton/styles.ts
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  text-align: center;
`;
